"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringElementCollection = void 0;
const ParenthesisOpen_1 = require("../ParenthesisOpen");
const ParenthesisClose_1 = require("../ParenthesisClose");
const OperatorString_1 = require("../OperatorString");
const AtomicPredicateString_1 = require("../AtomicPredicateString");
const NotString_1 = require("../NotString");
const StringElementNotFoundError_1 = require("../../errors/StringElementNotFoundError");
// noinspection JSMethodCanBeStatic
class StringElementCollection {
    constructor(stringElements = []) {
        this.POSSIBLE_ELEMENT_BY_PREVIOUS_TYPE = new Map([
            [undefined, [NotString_1.NotString, ParenthesisOpen_1.ParenthesisOpen, AtomicPredicateString_1.AtomicPredicateString]],
            [NotString_1.NotString, [AtomicPredicateString_1.AtomicPredicateString, ParenthesisOpen_1.ParenthesisOpen]],
            [ParenthesisOpen_1.ParenthesisOpen, [NotString_1.NotString, ParenthesisOpen_1.ParenthesisOpen, AtomicPredicateString_1.AtomicPredicateString]],
            [ParenthesisClose_1.ParenthesisClose, [ParenthesisClose_1.ParenthesisClose, OperatorString_1.OperatorString]],
            [OperatorString_1.OperatorString, [NotString_1.NotString, ParenthesisOpen_1.ParenthesisOpen, AtomicPredicateString_1.AtomicPredicateString]],
            [AtomicPredicateString_1.AtomicPredicateString, [ParenthesisClose_1.ParenthesisClose, OperatorString_1.OperatorString]],
        ]);
        this.stringElements = stringElements.map(this.createCopy);
        this.buildLinkedListReferences();
    }
    append(element) {
        this.stringElements.push(this.createCopy(element));
        this.buildLinkedListReferences(this.stringElements.length - 2);
    }
    getFirst() {
        return this.stringElements[0];
    }
    getLast() {
        return this.stringElements[this.stringElements.length - 1];
    }
    getByType(typeClass) {
        return this.stringElements.filter(element => element instanceof typeClass);
    }
    asArray() {
        return this.stringElements;
    }
    asLinkedList() {
        return this.stringElements[0];
    }
    getNextPossibleElementClasses() {
        var _a;
        return this.POSSIBLE_ELEMENT_BY_PREVIOUS_TYPE.get((_a = this.getLast()) === null || _a === void 0 ? void 0 : _a.constructor);
    }
    insertBefore(targetElement, elementToInsert) {
        const offset = 0;
        this.insert(targetElement, elementToInsert, offset);
    }
    insertAfter(targetElement, elementToInsert) {
        const offset = 1;
        this.insert(targetElement, elementToInsert, offset);
    }
    containsDifferentOperatorStrings() {
        let element = this.asLinkedList();
        const operatorStrings = [];
        while (element) {
            if (element instanceof OperatorString_1.OperatorString) {
                operatorStrings.push(element);
            }
            if (element instanceof ParenthesisOpen_1.ParenthesisOpen) {
                element = element.getClosingParenthesis();
            }
            element = element.getNext();
        }
        const operatorSet = new Set(operatorStrings.map(operatorString => operatorString.getOperator()));
        return operatorSet.size > 1;
    }
    incrementNestingIndexBetween(firstToIncrement, lastToIncrement) {
        firstToIncrement.incrementNestingIndex();
        if (firstToIncrement === lastToIncrement) {
            return;
        }
        this.incrementNestingIndexBetween(firstToIncrement.getNext(), lastToIncrement);
    }
    wrap(elementBefore, firstWrappedElement, lastWrappedElement, elementAfter) {
        this.insertBefore(firstWrappedElement, elementBefore);
        this.insertAfter(lastWrappedElement, elementAfter);
        this.incrementNestingIndexBetween(firstWrappedElement, lastWrappedElement);
    }
    getIndexOf(element) {
        const index = this.stringElements.findIndex(stringElement => stringElement === element);
        if (index === -1) {
            throw new StringElementNotFoundError_1.StringElementNotFoundError(element);
        }
        return index;
    }
    get length() {
        return this.stringElements.length;
    }
    buildLinkedListReferences(startingIndex = 0, endIndex = this.stringElements.length - 1) {
        let index = Math.max(startingIndex, 0);
        const lastIndex = Math.min(endIndex, this.stringElements.length - 1);
        while (index <= lastIndex) {
            const element = this.stringElements[index];
            element.setPrevious(null);
            element.setNext(null);
            if (index > 0) {
                element.setPrevious(this.stringElements[index - 1]);
            }
            if (index < this.stringElements.length - 1) {
                element.setNext(this.stringElements[index + 1]);
            }
            index++;
        }
    }
    createCopy(element) {
        return Object.assign(Object.create(Object.getPrototypeOf(element)), element);
    }
    insert(targetElement, elementToInsert, offset) {
        const index = this.getIndexOf(targetElement);
        const insertAtIndex = this.insertElement(index, offset, elementToInsert);
        const leftNeighbourIndex = insertAtIndex - 1;
        const rightNeighbourIndex = insertAtIndex + 1;
        this.buildLinkedListReferences(leftNeighbourIndex, rightNeighbourIndex);
    }
    insertElement(index, offset, elementToInsert) {
        const insertAtIndex = index + offset;
        this.stringElements.splice(insertAtIndex, 0, elementToInsert);
        return insertAtIndex;
    }
}
exports.StringElementCollection = StringElementCollection;
//# sourceMappingURL=StringElementCollection.js.map